import React from 'react';
import { Box, Container, Divider, Flex, HStack, Image, Link, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'i18n';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <Box
      as="footer"
      bg="gray.50"
      borderTop="1px solid"
      borderColor="gray.100"
      mt={{ base: 10, md: 16 }}
    >
      <Container maxW="container.xl" px={{ base: 4, md: 6 }} py={{ base: 8, md: 10 }}>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'flex-end' }}
          gap={{ base: 5, md: 6 }}
        >
          <Stack spacing={2}>
            <HStack spacing={2}>
              <Image
                src="/android-chrome-192x192.png"
                alt="Social Panel"
                boxSize="28px"
                borderRadius="6px"
              />
              <Text fontWeight={700} color="gray.800">
                {t('footer.brand')}
              </Text>
            </HStack>
            <Text fontSize="sm" color="gray.500" maxW="md">
              {t('footer.description')}
            </Text>
          </Stack>

          <Stack spacing={2} fontSize="sm" align={{ base: 'flex-start', md: 'flex-end' }}>
            <HStack spacing={{ base: 3, md: 4 }} flexWrap="wrap" rowGap={2}>
              <Link as={RouterLink} to="/legal" color="gray.600" _hover={{ color: 'blue.500' }}>
                {t('footer.legal')}
              </Link>
              <Link
                as={RouterLink}
                to="/privacy-policy"
                color="gray.600"
                _hover={{ color: 'blue.500' }}
              >
                {t('footer.privacy')}
              </Link>
              <Link
                as={RouterLink}
                to="/terms-of-service"
                color="gray.600"
                _hover={{ color: 'blue.500' }}
              >
                {t('footer.terms')}
              </Link>
            </HStack>
            <Text color="gray.400" fontSize="xs">
              {t('footer.copy', { year })}
            </Text>
          </Stack>
        </Flex>
        <Divider mt={{ base: 6, md: 8 }} borderColor="gray.200" />
        <Text
          fontSize="xs"
          color="gray.400"
          mt={4}
          textAlign="center"
          px={{ base: 2, md: 0 }}
          lineHeight="1.7"
        >
          {t('footer.support')}
        </Text>
      </Container>
    </Box>
  );
}
